export const TIKTOK_COLOR = 'var(--black)';
